<template>
    <div class="TableLegend">
        <div class="legend-items">
            <div
                v-for="item in legendItems"
                :key="item.key"
                class="legend-item"
                :class="{ 'is-active': item.active }"
            >
                <div class="legend-indicator" :class="item.indicatorClass"></div>
                <span class="legend-text">{{ item.label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableLegend',
    props: {
        legendItems: {
            type: Array,
            required: true,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.TableLegend {
    display: flex;
    align-items: center;
    gap: 12px;

    .legend-items {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: nowrap;
    }

    .legend-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 0.7rem;
        color: var(--color-text);
        white-space: nowrap;

        &.is-active {
            .legend-indicator {
                opacity: 1;
            }
        }

        .legend-indicator {
            width: 12px;
            height: 12px;
            border-radius: 2px;
            flex-shrink: 0;

            &.warning {
                background-color: var(--color-red);
            }

            &.empty {
                background-color: var(--color-text-gray);
            }

            &.flatrate {
                background-color: var(--color-blue-dark);
            }

            &.unregistered {
                background-color: var(--color-orange);
            }

            &.error {
                background-color: var(--color-red);
            }

            &.success {
                background-color: var(--color-green-dark);
            }

            &.info {
                background-color: var(--color-blue);
            }

            &.gps {
                background-color: var(--color-green);
            }

            &.assigned {
                background-color: var(--color-text-secondary);
            }
        }

        .legend-text {
            white-space: nowrap;
        }
    }

    @media screen and (max-width: $breakpoint-tablet-portrait) {
        padding: 4px 8px;
        gap: 8px;

        .legend-items {
            gap: 12px;
        }

        .legend-item {
            font-size: 0.65rem;
            gap: 3px;

            .legend-indicator {
                width: 10px;
                height: 10px;
            }
        }
    }
}
</style>
